<template>

   <LoadingSpinner v-if="loading" />   
    <div  id="app" v-else>
      <Auth />
      <router-view />
      <Modal />
      <Footer />
      <Notifications/>
   </div>  
</template>

<script>
import Vue from 'vue';
import Auth from '@/components/Auth.vue';
import Footer from '@/components/Footer.vue';
import Modal from '@/components/Modal.vue';
import Notifications from '@/components/Notifications.vue';

import LoadingSpinner from './components/LoadingSpinner.vue';

import VTooltip from 'v-tooltip';
import VCalendar from 'v-calendar';
import { mapGetters } from 'vuex';

Vue.use(VTooltip);
Vue.use(VCalendar, {
  
});

export default {
  name: 'app',
  components: {
    Auth,
    Footer,
    Modal,

    Notifications,
    LoadingSpinner
  },
  computed: {
    ...mapGetters(['loading'])
  },
  watch: {
    loading(val) {
      console.log('Loading state:', val);
    }
  },
  mounted() {
    console.log('Mounted: loading state is', this.loading);
    console.log('Mounted: store state is', this.$store.state.auth.loading);

  }
};


// Namespace setting from any URL
function getQueryString(field) {
  const href = window.location.href;
  const reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
  const str = reg.exec(href);
  return str ? str[1] : null;
};
const ns = getQueryString('data-version');
if (ns) {
  sessionStorage.VUE_APP_NAMESPACE = ns;
}
// Namespace setting ends


</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
